export interface AcquisitionParams {
  source?: string;
  medium?: string;
  campaign?: string;
  term?: string;
  content?: string;
  gclid?: string;
}

const STORAGE_KEY = "blc_acquisition";

const URL_PARAM_TO_FIELD: [string, keyof AcquisitionParams][] = [
  ["utm_source", "source"],
  ["utm_medium", "medium"],
  ["utm_campaign", "campaign"],
  ["utm_term", "term"],
  ["utm_content", "content"],
  ["gclid", "gclid"],
];

// Reads utm_*/gclid query params from the landing URL and persists them to localStorage as
// first-touch attribution, so a baby profile created minutes or days later (after App.tsx's
// history.replaceState has already stripped the query string) can still be stamped with the
// campaign that brought the visitor in. Must run before that replaceState call, so it's called
// at module load in main.tsx rather than from a React effect. Never overwrites an existing
// stored value — only the first campaign a visitor arrives from is recorded.
export function captureAcquisitionParams() {
  if (localStorage.getItem(STORAGE_KEY)) return;
  const params = new URLSearchParams(window.location.search);
  const value: AcquisitionParams = {};
  for (const [param, field] of URL_PARAM_TO_FIELD) {
    const v = params.get(param);
    if (v) value[field] = v;
  }
  if (Object.keys(value).length > 0) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
  }
}

export function getStoredAcquisitionParams(): AcquisitionParams | null {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as AcquisitionParams;
    return Object.keys(parsed).length > 0 ? parsed : null;
  } catch {
    return null;
  }
}
